import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  disabled?: boolean
}

export const Div = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
  background: var(--Cinza-Cinza-muito-mais-calro---F5, #f5f5f5);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 4px;
  width: fit-content;
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`

export const ToggleOption = styled.button`
  border: none !important;
  padding: 8px 16px;
  font-size: 14px;
  white-space: nowrap;
  font-family: 'Inter';
  background-color: ${(props: IStyleProps) => {
    if (props.disabled) return `${Theme.pallete.SECONDARY3}`
    return `${Theme.pallete.QUATERNARY3}`
  }};

  cursor: ${(props: IStyleProps) => {
    if (props.disabled) return 'default'
    return 'pointer'
  }};

  &:hover {
    background-color: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.pallete.SECONDARY3}`
      return '##DF7A581a'
    }};
    background-color: ${({ theme }) => theme.colors.toggleHover};
  }

  .selected-toggle {
    border: none !important;
    cursor: pointer;
    color: #f5f5f5;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px rgba(255, 198, 0, 0.5);
    background-color: ${Theme.pallete.TERTIARY};
  }
  background-color: ${({ theme }) => theme.colors.toggleUnselected};
`

export const SelectedToggle = styled.button`
  border: none !important;
  font-size: 14px;
  padding: 8px 16px;
  font-family: 'Inter';
  white-space: nowrap;
  cursor: pointer;
  color: #f5f5f5;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px black;
  background-color: ${Theme.pallete.TERTIARY};
  background-color: ${({ theme }) => theme.colors.primary};
`
